import * as Sentry from '@sentry/browser';

import { SENTRY_TAG_SYSTEM_DOMAIN_ID } from '../../utils/constants/sentry';

type UserContextParams = {
  id: string;
  system_domain_id?: string | undefined | null;
};

export function initSentryUserContext({
  id,
  system_domain_id,
}: UserContextParams) {
  const systemDomainId = system_domain_id ?? undefined;
  const scope = Sentry.getCurrentScope();
  scope.setUser({
    id,
    systemDomainId,
  });
  scope.setTag(SENTRY_TAG_SYSTEM_DOMAIN_ID, systemDomainId);
}
